import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './index.css';
import { TodoProvider } from './components/Todo_Context';
import Home from './components/Home';
import Notes from './components/Notes';
import Account from './components/Account';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
<TodoProvider>
<Router>
  <Routes>
    <Route path='/' element={<Home/>}/>
    <Route path='/components/Notes' element={<Notes/>}/>
    <Route path='/components/Account' element={<Account/>}/>
  </Routes>
</Router>
</TodoProvider>
);

